import { render, staticRenderFns } from "./ActivityTotalScoreList.vue?vue&type=template&id=3a9418a8&"
import script from "./ActivityTotalScoreList.vue?vue&type=script&lang=js&"
export * from "./ActivityTotalScoreList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports